import BaseChanger from './BaseChanger'

export default class {
  constructor() {

    const domBaseChanger = document.querySelector('[data-js="base-changer"]');
    if (domBaseChanger) new BaseChanger(domBaseChanger);
  }
}
